/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SovSummaryResponseDto
 */
export interface SovSummaryResponseDto {
    /**
     * Total insurable value
     * @type {string}
     * @memberof SovSummaryResponseDto
     */
    totalTiv: string;
    /**
     * Incidental total insurable value
     * @type {string}
     * @memberof SovSummaryResponseDto
     */
    incidentalTiv: string;
    /**
     * List of countries used for incidental TIV calculation
     * @type {Array<string>}
     * @memberof SovSummaryResponseDto
     */
    incidentalTivCountries: Array<string>;
    /**
     * Percentage of locations with accurate coordinates
     * @type {string}
     * @memberof SovSummaryResponseDto
     */
    locationAccuracyPercentage: string;
}

/**
 * Check if a given object implements the SovSummaryResponseDto interface.
 */
export function instanceOfSovSummaryResponseDto(value: object): value is SovSummaryResponseDto {
    if (!('totalTiv' in value) || value['totalTiv'] === undefined) return false;
    if (!('incidentalTiv' in value) || value['incidentalTiv'] === undefined) return false;
    if (!('incidentalTivCountries' in value) || value['incidentalTivCountries'] === undefined) return false;
    if (!('locationAccuracyPercentage' in value) || value['locationAccuracyPercentage'] === undefined) return false;
    return true;
}

export function SovSummaryResponseDtoFromJSON(json: any): SovSummaryResponseDto {
    return SovSummaryResponseDtoFromJSONTyped(json, false);
}

export function SovSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SovSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalTiv': json['totalTiv'],
        'incidentalTiv': json['incidentalTiv'],
        'incidentalTivCountries': json['incidentalTivCountries'],
        'locationAccuracyPercentage': json['locationAccuracyPercentage'],
    };
}

export function SovSummaryResponseDtoToJSON(json: any): SovSummaryResponseDto {
    return SovSummaryResponseDtoToJSONTyped(json, false);
}

export function SovSummaryResponseDtoToJSONTyped(value?: SovSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalTiv': value['totalTiv'],
        'incidentalTiv': value['incidentalTiv'],
        'incidentalTivCountries': value['incidentalTivCountries'],
        'locationAccuracyPercentage': value['locationAccuracyPercentage'],
    };
}

